import Outdoors from './outdoors';
export default Outdoors;